module.exports = __webpack_public_path__ + "h5/img/animition.f6f67554.gif";